import React from 'react';
import { validated } from 'react-custom-validation';
import Dropzone from 'react-dropzone';

import { isRequired } from 'utils/validations';
import { CHECKLIST_ITEM_TYPES_LOOKUP } from 'utils/constants';

import ActionMenu from 'components/ActionMenu';
import ActionMenuButton from 'components/ActionMenuButton';
import Form from 'components/Form';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import Icon from 'components/Icon';
import Input from 'components/Input';
import ModalButton from 'components/ModalButton';
import TextArea from 'components/TextArea';

class ChecklistAddItemForm extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        handleAnswerTypeChange: React.PropTypes.func.isRequired,
        handleChange: React.PropTypes.func.isRequired,
        handleThumbnailChange: React.PropTypes.func.isRequired,
        item: React.PropTypes.object.isRequired,
        onValid: React.PropTypes.func.isRequired,
        onInvalid: React.PropTypes.func.isRequired
    };

    _handleDrop(file) {
        this.props.handleThumbnailChange(file[0]);
    }

    _handleTriggerClick(event) {
        let target = event.target;

        while(target.getAttribute('class') == null || target.getAttribute('class') !== 'answer-type__action-menu') {
            target = target.parentNode;
        }

        target.querySelector('.action-menu').classList.add('active');
    }

    render() {
        let { closeModal, handleAnswerTypeChange, handleChange, item, onValid, onInvalid, $field, $validation } = this.props;

        return (
            <Form className="checklist-add-item__form modal-form" onSubmit={(event) => event.preventDefault()}>
                <FormRow>
                    <Input type="text"
                           name="name"
                           placeholder="Checklist Item"
                           value={item.name || ''}
                           {...$field('name', (event) => handleChange(event))} />
                    {$validation.name.show && <FormValidationMessage>{$validation.name.error.reason}</FormValidationMessage>}
                </FormRow>

                <FormRow className="checklist-add-item__answer-type">
                    <div>
                        <Icon icon="image" /> Answer Type
                    </div>
                    <div className="answer-type__action-menu">
                        <button type="button"
                                className="answer-type__trigger"
                                onClick={this._handleTriggerClick.bind(this)}>
                            {CHECKLIST_ITEM_TYPES_LOOKUP[item.type]} <Icon icon="carrot-right" />
                        </button>
                        <ActionMenu>
                            {Object.keys(CHECKLIST_ITEM_TYPES_LOOKUP).map((type, index) => {
                                return (
                                    <ActionMenuButton type="button" onClick={handleAnswerTypeChange.bind(this, type)} key={index}>
                                        {CHECKLIST_ITEM_TYPES_LOOKUP[type]}
                                    </ActionMenuButton>
                                )
                            })}
                        </ActionMenu>
                    </div>
                </FormRow>

                <FormRow className="checklist-add-item__image">
                    <Dropzone className="checklist-add-item__drop"
                              activeClassName="checklist-add-item__drop--active"
                              accept="image/*"
                              multiple={false}
                              onDrop={this._handleDrop.bind(this)}
                              ref={(node) => { this.dropzone = node; }}
                              style={{}}
                              activeStyle={{}}>
                        <Icon icon="camera" /> {item.thumbnail == null ? 'Add Image' : 'Change Image'}

                        {item.thumbnail == null ? (
                            <Icon icon="carrot-right" />
                        ) : (
                            <div className="checklist-add-item__image-preview">
                                {item.thumbnail.id == null ? <img src={item.thumbnail.preview} alt="" /> : <img src={`${process.env.API_URL}rest/file/${item.thumbnail.id}`} alt="" />}
                            </div>
                        )}
                    </Dropzone>
                </FormRow>

                <FormRow className="form-row">
                    <TextArea name="information"
                              placeholder="Description"
                              onChange={(event) => handleChange(event)}
                              value={item.information || ''} />
                </FormRow>
                <div className="modal__buttons">
                    <ModalButton icon="check"
                                 onClick={(event) => {
                                     event.preventDefault();
                                     this.props.$submit(onValid, onInvalid)}}
                                 text="Done" />
                    <ModalButton className="modal-button--cancel"
                                 icon="cancel"
                                 onClick={closeModal.bind(this)}
                                 text="Cancel" />
                </div>
            </Form>
        );
    }
}

function checklistAddItemFormValidationConfig(props) {
    const { name } = props.item;
    return {
        fields: ['name'],
        validations: {
            name: [
                [isRequired, name]
            ]
        }
    }
}

export default ChecklistAddItemForm = validated(checklistAddItemFormValidationConfig)(ChecklistAddItemForm);



// WEBPACK FOOTER //
// ./src/containers/ContentPage/modals/ChecklistAddItemModal/ChecklistAddItemForm.js